module.exports = {
      id: "account-usage",
      viewBox: "0 0 19.7 21.5",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#account-usage",
      toString: function () {
        return this.url;
      }
    }